import { render, staticRenderFns } from "./modalWCards.vue?vue&type=template&id=1b09e098&scoped=true&"
import script from "./modalWCards.vue?vue&type=script&lang=js&"
export * from "./modalWCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09e098",
  null
  
)

export default component.exports